import Drag from './Drag';
import DragMaterial from './DragMaterial';

export default Drag;
export {
    DragMaterial
}


// WEBPACK FOOTER //
// ./src/components/Drag/index.js